import { render, staticRenderFns } from "./NomenclatureEditCard.vue?vue&type=template&id=1c4216c2&scoped=true&"
import script from "./NomenclatureEditCard.vue?vue&type=script&lang=js&"
export * from "./NomenclatureEditCard.vue?vue&type=script&lang=js&"
import style0 from "./NomenclatureEditCard.vue?vue&type=style&index=0&id=1c4216c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4216c2",
  null
  
)

export default component.exports